/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Link } from "react-router-dom";

// @mui material components
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// components
import SoftBox from "components/SoftBox";

function ActionCell({ item }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  return (
    <SoftBox display="flex" alignItems="center">
      <SoftBox color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }} onClick={handleOpenMenu}>
        <Icon sx={{ fontWeight: "bold" }}>more_vert</Icon>
      </SoftBox>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu} keepMounted>
        <MenuItem
          component={Link}
          to={`/templates/journal-voucher-8/${item._id || item.id}/view`}
          onClick={handleCloseMenu}
        >
          Xem chi tiết
        </MenuItem>
      </Menu>
    </SoftBox>
  );
}

export default ActionCell;
